module.exports = __webpack_public_path__ + "img/weldit_logo.76d88849.png";